import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { App_FormFieldCasesDynamiques } from 'src/app/utils/interfaces';

@Component({
  selector: 'app-c-cases-dynamiques-edition',
  templateUrl: './c-cases-dynamiques-edition.component.html',
  styleUrls: ['./c-cases-dynamiques-edition.component.scss'],
})
export class CCasesDynamiquesEditionComponent {
  @Input({ required: true }) field!: App_FormFieldCasesDynamiques;
  @Input({ required: true }) cFormArray!: FormArray<FormGroup<{ label: FormControl<string | null>; value: FormControl<boolean | null>}>>;
  @Input({ required: true }) blocName!: string;
  @Input({ required: true }) disabledField!: boolean;

  constructor() { }
  ngOnInit(): void {
    if (this.field?.pre_requis && this.cFormArray) {
      this.setupToggleCascade();
    }
  }

  setupToggleCascade(): void {
    this.cFormArray.controls.forEach((control, index) => {
      const formGroup = control as FormGroup;
      const valueControl = formGroup.get('value');

      if (valueControl) {
        valueControl.valueChanges.subscribe((isChecked: boolean) => {
          if (!isChecked) {
            for (let j = index + 1; j < this.cFormArray.length; j++) {
              const nextGroup = this.cFormArray.at(j) as FormGroup;
              const nextValue = nextGroup.get('value');
              if (nextValue?.value) {
                nextValue.setValue(false, { emitEvent: false });
              }
            }
          }
        });
      }
    });
  }
}
